/*
 * @Description: 
 * @Author: ke wen
 * @Date: 2021-01-21 16:56:00
 * @LastEditTime: 2021-02-25 11:20:48
 * @LastEditors: LastEditors
 * @Reference: 
 */
 

import CryptoJS from 'crypto-js'
 
const KEY = CryptoJS.enc.Utf8.parse('retedfgd'); // 'retedfgd' 与后台一致
const IV = CryptoJS.enc.Utf8.parse('asdqwe'); // 'asdqwe' 与后台一致
 
// AES加密 ：字符串 key iv  返回base64
 
export function Encrypt(str, keyStr, ivStr) {
    let key = KEY;
    let iv = IV;
    
    let keyStr1 = CryptoJS.MD5(keyStr)
    // if (keyStr && ivStr) {
    //     key = CryptoJS.enc.Utf8.parse(keyStr);
    //     iv = CryptoJS.enc.Utf8.parse(ivStr);
    // }
    // key = CryptoJS.enc.Utf8.parse(keyStr1);
    // iv = CryptoJS.enc.Utf8.parse(keyStr1);
    let srcs = CryptoJS.enc.Utf8.parse(str);
    var encrypted = CryptoJS.AES.encrypt(srcs, keyStr1, {
        iv: keyStr1,
        // mode: CryptoJS.mode.ECB, 
        mode: CryptoJS.mode.CBC,  // mode 与后台一致
        padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
 
 
 
// AES 解密 ：字符串 key iv  返回base64
 
export function Decrypt(str, keyStr, ivStr) {
    let key = KEY;
    let iv = IV;
    

    let keyStr1 = CryptoJS.MD5(keyStr)
    // if (keyStr && ivStr) {
    //     key = CryptoJS.enc.Utf8.parse(keyStr);
    //     iv = CryptoJS.enc.Utf8.parse(ivStr);
    // }
    // key = CryptoJS.enc.Utf8.parse(keyStr);
    // iv = CryptoJS.enc.Utf8.parse(keyStr);
    let base64 = CryptoJS.enc.Base64.parse(str);
    let src = CryptoJS.enc.Base64.stringify(base64);
 
    var decrypt = CryptoJS.AES.decrypt(src, keyStr1, {
        iv: keyStr1,
        // mode: CryptoJS.mode.ECB, 
        mode: CryptoJS.mode.CBC, // 保持一致
        padding: CryptoJS.pad.Pkcs7
    });
    
    
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
    // return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}